import { UserbotBatches } from "../../interfaces"

export type BatchTargetMode = "selected" | "role" | "all"

export interface BuildCreateBatchDtoInput {
  templateId: string
  targetMode: BatchTargetMode
  selectedClientIds: string[]
  role: string
  params: Record<string, unknown>
  staggerMs: number
  dryRun?: boolean
}

/** Вариант цели → DTO POST /account-batches; clientIds дедуплицируются
 * с сохранением порядка (контракт: «clientIds ≥ 1, дедуп»). */
export const buildCreateBatchDto = (
  input: BuildCreateBatchDtoInput,
): UserbotBatches.CreateAccountBatchDto => {
  const target: UserbotBatches.AccountBatchTarget =
    input.targetMode === "selected"
      ? { clientIds: [...new Set(input.selectedClientIds)] }
      : input.targetMode === "role"
        ? { role: input.role }
        : { all: true }
  return {
    templateId: input.templateId,
    target,
    params: input.params,
    staggerMs: input.staggerMs,
    ...(input.dryRun ? { dryRun: true } : {}),
  }
}
